<template>
  <v-container fluid class="px-0">
    <v-expansion-panels v-model="searchPanel" class="mb-4" v-if="!loadDefault">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="4">
              Paieška
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <form @keydown.enter.prevent="submit()">
            <div class="dataContainer">
              <v-row class="mb-3">
                <v-col cols="12" md="3">
                  <el-text-field
                    label="Gauto pranešimo registracijos numeris"
                    v-model="extraData.zus_numeris"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <el-text-field
                    label="Dokumento Nr."
                    v-model="extraData.dokumento_numeris"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <el-text-field
                    label="Identifikavimo kodas (IDK)"
                    v-model="extraData.identifikavimo_kodas"
                    idk
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <el-text-field
                    label="Adresato el. paštas"
                    v-model="extraData.zus_adresato_el_pastas"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <el-autocomplete
                    :items="filteredPranesimasRusys"
                    itemvalue="value"
                    itemtext="text"
                    label="Pranešimo rūšis"
                    multiple
                    v-model="extraData.zus_dokumento_rusis_kla_id"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <el-date-picker
                    label="Pranešimo data nuo"
                    v-model="extraData.zus_busenos_data_nuo"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <el-date-picker
                    label="Pranešimo data nuo"
                    v-model="extraData.zus_busenos_data_iki"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <el-text-field
                    label="Skolininko kodas"
                    v-model="extraData.skolininkas_kodas"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <el-text-field
                    label="Skolininko pavadinimas"
                    v-model="extraData.skolininkas_pavadinimas"
                  />
                </v-col>
                <v-col cols="12" md="3" v-if="showPriskirtasAsmuo">
                  <el-text-field
                    label="Priskirtas asmuo"
                    v-model="extraData.zus_priskirta"
                  />
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12">
                  <el-button
                    :loading="loading"
                    primary
                    @click.native.stop="searchData()"
                  >
                    Ieškoti
                  </el-button>
                  <el-button :loading="loading" @click.native="clearData()">
                    Išvalyti
                  </el-button>
                </v-col>
              </v-row>
            </div>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../../mixins/userRole'

export default {
  name: 'DashboardPranesimaiSearch',
  props: {
    loading: Boolean,
  },
  mixins: [userRole],
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    mainData: {},
    extraData: {},
    pranesimas_rusys: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      return this.searchPanel === 0
    },
    filteredPranesimasRusys() {
      return this.pranesimas_rusys.map(item => {
        return item
      })
    },
    showPriskirtasAsmuo() {
      return this.isJuridinis
    },
    isJuridinis() {
      return this.roleOr(['DT_JA', 'DT_JA_Skaito'])
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loadDefault = true

      const data = {
        klasifikatoriai: ['zurnalas_siunciami_rusys'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.pranesimas_rusys = res.data.list.zurnalas_siunciami_rusys

          if (
            this.searchParams &&
            this.searchParams.route === this.$route.name
          ) {
            this.mainData = this.searchParams.mainData
            this.extraData = this.searchParams.extraData
            this.searchPanel = this.searchParams.isExpanded ? 0 : null
          }

          this.checkGautasPranesimas()

          this.searchData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    searchData() {
      let searchData = {
        ...this.mainData,
        ...this.extraData,
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {
        objektas: null,
        veiksmas: [],
      }
    },
    submit() {
      this.searchData()
    },
    clearRusis() {
      //
    },
    checkGautasPranesimas() {
      const gautasPranesimas = sessionStorage.getItem('gautasPranesimas')
      if (gautasPranesimas && gautasPranesimas.length > 0) {
        this.extraData.zus_numeris = gautasPranesimas
        this.searchPanel = 0
        this.$emit('scollToPranesimai')
      }
      sessionStorage.setItem('gautasPranesimas', '')
    },
  },
}
</script>
